import { Typography, Stack, Box, Divider, useTheme } from '@mui/material'
import { getDurationStrings } from '@shared/common'
import { i18WithDefault as t } from '@shared/locales'
import { PaymentSettingAdminDto } from 'service-api/src/types'

export interface FeeStructureProps {
  fees: PaymentSettingAdminDto[]
  type: 'earlyArrival' | 'lateDeparture'
}

export const FeeStructure = ({ fees, type }: FeeStructureProps) => {
  const theme = useTheme()

  if (fees.length < 1) {
    return
  }

  const sortedFees = fees.sort((feeA, feeB) =>
    type === 'earlyArrival' ? feeA.before! - feeB.before! : feeA.after! - feeB.after!
  )

  const feeDurations = sortedFees.map((fee) => (type === 'earlyArrival' ? fee.before! : fee.after!))

  const durations = getDurationStrings(feeDurations, { abbreviate: true, showRange: true })

  const prefix = type === 'earlyArrival' ? t('feeStructure.early') : t('feeStructure.late')

  return (
    <Stack sx={{ backgroundColor: theme.palette.background.grey, p: 1, borderRadius: 1 }}>
      <Stack>
        {sortedFees.map((fee, idx: number) => {
          return (
            <Stack key={idx} px={1}>
              <Box display="flex" flexDirection="row" alignItems="baseline" justifyContent="space-between" gap={1}>
                <Typography variant="body2" sx={{ minWidth: 0 }}>
                  {prefix} ({durations[idx]})
                </Typography>
                {/* If `fee.value` exists this is a fixed value fee else it is a rate-based/percentage fee */}
                {fee.value ? (
                  <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
                    ${fee.value} {t('feeStructure.perPet')}
                  </Typography>
                ) : (
                  <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
                    {fee.rate! * 100}% {t('feeStructure.ofOfferRate')}
                  </Typography>
                )}
              </Box>

              {idx !== fees.length - 1 && <Divider sx={{ my: 1 }} />}
            </Stack>
          )
        })}
      </Stack>
    </Stack>
  )
}
